import React, { Component } from "react";
import { connect } from "react-redux";
import { breadcrumbs } from "../../../../actions/appActions";
import { push } from "react-router-redux";
import {
  ArchiveDefault,
  ArchiveInitiatives,
  ArchiveRequest,
} from "../../components/grids/ArchiveGrid";
import { isInternal, isLegitimate, isOfficialAdmin } from "../../CroUtils";
import { noop } from "lodash";
import loginInfo from "../../components/LoginInfo";
import {
  finallyDeleteOfficials,
  getArchivedCsv,
  unarchiveOfficials,
} from "../../CroActions";

class Archive extends Component {
  state = {
    items: [], //dummy.. import api action doesnt return anything, this is to force reload grid from api
    selected: [],
  };

  getTab() {
    const tabs = [
      { label: "Funkcionáři", value: "funkcionari" },
      { label: "Žádosti", value: "zadosti" },
      { label: "Podnety", value: "podnety" },
    ];
    return tabs.find((tab) => tab.value === this.props.params.tab);
  }

  componentWillMount() {
    this.props.breadcrumbs([{ label: "Archivace" }]);
    if (this.props.params.tab === undefined) {
      this.props.params.tab = "funkcionari";
    }
  }

  onRowClick =
    (url) =>
    ({ id }) => {
      const tabValue = this.getTab().value;
      const { auth } = this.props;
      if (tabValue === "funkcionari") {
        this.props.push(`${url}/funkcionari/form/${id}`);
      } else if (tabValue === "zadosti" && !isOfficialAdmin(auth)) {
        this.props.push(`${url}/zadosti/form/${id}`);
      } else if (tabValue === "podnety" && !isOfficialAdmin(auth)) {
        this.props.push(`${url}/podnety/form/${id}`);
      }
    };

  onTabClick = (url, tab) => () => this.props.push(`${url}/archivace/${tab}`);

  onRemove = () => {
    const { auth } = this.props;
    if (isInternal(auth) || isOfficialAdmin(auth)) {
      return this.onRemoveOfficials(auth);
    }
    return noop;
  };

  onSend = () => {
    const { auth } = this.props;
    if (isInternal(auth) || isOfficialAdmin(auth)) {
      return this.onSendToArchive(auth);
    }
    return noop;
  };

  onUnarchive = () => {
    const { auth } = this.props;
    if (isInternal(auth) || isOfficialAdmin(auth)) {
      return this.onUnarchiveOfficials(auth);
    }
    return noop;
  };
  onCheckboxFn = () => {
    const { auth, onShowAppeal } = this.props;

    if (isInternal(auth)) {
      return onShowAppeal;
    }
    return noop;
  };

  onRemoveOfficials = (auth) => async (ids) => {
    await finallyDeleteOfficials(
      ids,
      auth,
      this.getTab().value,
    )(this.props.dispatch);
    this.setState({ items: [...this.state.items, 0] });
  };

  onUnarchiveOfficials = (auth) => async (ids) => {
    const officialIds = ids && Array.isArray(ids) ? ids : [ids];
    await unarchiveOfficials(
      officialIds,
      auth,
      this.getTab().value,
    )(this.props.dispatch);
    this.setState({ items: [...this.state.items, 0] });
  };

  onSendToArchive = (auth) => async (ids) => {
    await getArchivedCsv(ids, auth, this.getTab().value)(this.props.dispatch);
    this.setState({ items: [...this.state.items, 0] });
  };

  render() {
    const { auth } = this.props;
    const canDelete = isInternal(auth);
    const canEdit =
      isOfficialAdmin(auth) && this.getTab().value === "funkcionari";

    if (isLegitimate(auth)) {
      this.props.breadcrumbs([{ label: "Veřejní funkcionáři" }]);
    }

    const GridComponent =
      isInternal(auth) && this.getTab().value === "funkcionari"
        ? ArchiveDefault
        : this.getTab().value === "zadosti"
          ? ArchiveRequest
          : this.getTab().value === "podnety" && ArchiveInitiatives;
    const ApiUrl =
      isInternal(auth) && this.getTab().value === "funkcionari"
        ? `${auth.startUrl}/api/archivace/funkcionari`
        : this.getTab().value === "zadosti"
          ? `${auth.startUrl}/api/archivace/zadosti`
          : this.getTab().value === "podnety" &&
            `${auth.startUrl}/api/archivace/podnety`;
    return (
        <div className="archivePage">
          <div className="pageTabs pageTabs--archive">
            <div className="pageTabs__scroller">
              <button
                type="button"
                className={
                  this.getTab().value === "funkcionari"
                    ? "pageTabs__tab pageTabs__tab--active"
                    : "pageTabs__tab"
                }
                onClick={this.onTabClick(auth.startUrl, "funkcionari")}
              >
                Funkcionáři
              </button>

              <button
                type="button"
                className={
                  this.getTab().value === "zadosti"
                    ? "pageTabs__tab pageTabs__tab--active"
                    : "pageTabs__tab"
                }
                onClick={this.onTabClick(auth.startUrl, "zadosti")}
              >
                Žádosti
              </button>

              <button
                type="button"
                className={
                  this.getTab().value === "podnety"
                    ? "pageTabs__tab pageTabs__tab--active"
                    : "pageTabs__tab"
                }
                onClick={this.onTabClick(auth.startUrl, "podnety")}
              >
                Podněty
              </button>
            </div>
          </div>

          <GridComponent
            gridName="archiveGrid_all"
            url={ApiUrl}
            items={this.state.items}
            toolbarButtons={[]}
            deleting={canDelete}
            onRemove={this.onRemove()}
            deletingText="TRVALÉ VYMAZÁNÍ"
            onRowClick={this.onRowClick(auth.startUrl)}
            moreCheckboxFns={isInternal(auth)}
            fnText={"ODESLÁNÍ DO NÁRODNÍHO ARCHIVU"}
            onCheckboxFn={this.onSend()}
            allowCheck={isInternal(auth)}
            filtering={true}
            onEdit={this.onUnarchive()}
            editText={"NAVRÁTIT Z ARCHIVOVANÝCH"}
            editMultiple={true}
            editing={canEdit}
          />
        </div>
    );
  }
}

export default connect(null, { breadcrumbs, push })(loginInfo(Archive));
